/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type VehicleMaintenanceStatus = typeof VehicleMaintenanceStatus[keyof typeof VehicleMaintenanceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleMaintenanceStatus = {
  Planned: 'Planned',
  Ongoing: 'Ongoing',
  Completed: 'Completed',
} as const;
